export default __webpack_public_path__ + "static/media/face8.97dff809.svg";